export const SKELETON_APPEARANCE_DELAY_MS = 200
export const SKELETON_MINIMUM_VISIBLE_MS = 300

type SetSkeletonVisible = (visible: boolean) => void

export async function runWithSkeletonTiming(
  setVisible: SetSkeletonVisible,
  operation: () => Promise<void>,
): Promise<void> {
  let shownAt: number | null = null

  const showTimer = setTimeout(() => {
    shownAt = Date.now()
    setVisible(true)
  }, SKELETON_APPEARANCE_DELAY_MS)

  try {
    await operation()
  } finally {
    clearTimeout(showTimer)

    if (shownAt !== null) {
      const remaining = SKELETON_MINIMUM_VISIBLE_MS - (Date.now() - shownAt)
      if (remaining > 0) {
        await new Promise<void>((resolve) => setTimeout(resolve, remaining))
      }
      setVisible(false)
    }
  }
}
